module.exports = __webpack_public_path__ + "static/media/alice.d6dbfe27.png";